export default __webpack_public_path__ + "static/412-2e63f73bc94638fc425d472b4e43b7cd.gif";